var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('my-company-appusers-index',{attrs:{"create-form-url":"/appusers/create","open-existing-form-url":"/appusers/"}})
}
var staticRenderFns = []

export { render, staticRenderFns }